var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Inline } from "syf-component-library/ui/spacing";
import { CreditStatusText } from "./subcomponents";
import theme from "../../../theme";
var CreditChangeSection = function (_a) {
    var creditScores = _a.creditScores;
    var latestScore = creditScores[0], previousScore = creditScores[1];
    var changeInCredit = latestScore.creditScore - previousScore.creditScore;
    return (_jsx("div", { children: changeInCredit !== 0 && (_jsxs(_Fragment, { children: [_jsx(Inline, { size: "medium" }), changeInCredit > 0 ? (_jsx(FontAwesomeIcon, { color: theme.neonGreen, size: "lg", icon: faArrowUp })) : (_jsx(FontAwesomeIcon, { color: theme.red, size: "lg", icon: faArrowDown })), _jsx(Inline, { size: "xsmall" }), _jsx(CreditStatusText, __assign({ as: "p", weight: "semiBold" }, { children: changeInCredit.toString().replace("-", "") }))] })) }));
};
export default CreditChangeSection;
